import { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { oktaAuth } from '../utils/okta'

const RouteComponent = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.clear()
    oktaAuth.signOut()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return null
}

export const Route = createFileRoute('/logout')({
  component: RouteComponent,
})
